import { v4 as uuidv4 } from 'uuid';

export const dummyBlock = {
    "bot": {
        "text": {
            "1": "dummy",
            "2": ""
        }
    },
    "dummy": true
};

export const answerTypes = {
    "Validated": "validated",
    "NotValidated": "not-validated",
    "Summarized": "summarized"
}

export const answerMethods  = {
    "FAQ": "FAQ",
    "PAGE_SEARCH": "PAGE_SEARCH"
}

export const allLikeMessage = {
    en: "Thank you for your feedback. We will use this to improve our services.",
    hi: "आपके फ़ीडबैक के लिए धन्यवाद । हम इसका उपयोग अपनी सेवाओं को बेहतर बनाने के लिए करेंगे। ",
    or: "ଆପଣଙ୍କ ମତାମତ ପାଇଁ ଧନ୍ୟବାଦ। ଆମେ ଏହାକୁ ଆମର ସେବାଗୁଡ଼ିକୁ ଉନ୍ନତ କରିବା ପାଇଁ ବ୍ୟବହାର କରିବୁ।"
}

export const validatedAndNotValidatedDislikeMessage = {
    en: "Thank you for your feedback. We will use this to improve our services.         This answer was generated using the questions below. Would you like to know about any of them?",
    hi: "आपके फ़ीडबैक के लिए धन्यवाद । हम इसका उपयोग अपनी सेवाओं को बेहतर बनाने के लिए करेंगे।            यह उत्तर नीचे दिए गए प्रश्नों का उपयोग करके तैयार किया गया था। क्या आप उनमें से किसी के बारे में जानना चाहेंगे?",
    or: "ଆପଣଙ୍କ ମତାମତ ପାଇଁ ଧନ୍ୟବାଦ। ଏହି ଉତ୍ତରଟି ନିମ୍ନରେ ଥିବା ପ୍ରଶ୍ନଗୁଡ଼ିକୁ ବ୍ୟବହାର କରି ସୃଷ୍ଟି କରାଯାଇଥିଲା। ଆପଣ କ’ଣ ସେମାନଙ୍କ ମଧ୍ୟରୁ କୌଣସି ବିଷୟରେ ଜାଣିବାକୁ ଚାହାଁନ୍ତି?"
}

export const summarizedAnswerTitle = { en: "This answer is yet to be validated.", hi: "इस उत्तर की पुष्टि होना अभी बाकी है" }

export const botDisclaimerMessage = {
    'en': 'Use your discretion or consult your supervisor for guidance',
    'hi': 'कृपया समझदारी से निर्णय लें या मार्गदर्शन के लिए अपनी सुपरवाइज़र से परामर्श करें।',
    'or': 'ଆପଣଙ୍କ ବିବେଚନା ବ୍ୟବହାର କରନ୍ତୁ କିମ୍ବା ମାର୍ଗଦର୍ଶନ ପାଇଁ ଆପଣଙ୍କ ସୁପରଭାଇଜରଙ୍କ ସହିତ ପରାମର୍ଶ କରନ୍ତୁ।',
    'mr': 'कृपया आपल्या विवेकबुद्धीनुसार निर्णय घ्या किंवा मार्गदर्शनासाठी आपल्या सुपरवायझरचा सल्ला घ्या.'
}
export const langDisclaimer = {
    'en': `You have selected “English". Now you can ask questions in “English" Change language  here ☰`,
    'hi': `आपने "हिंदी" भाषा चुनी है। अब आप "हिंदी" में सवाल पूछ सकते हैं । भाषा यहाँ ☰ से बदलें`,
    'or': `ଆପଣ “ଓଡିଆ” ବାଛିଲେ। ବର୍ତ୍ତମାନ ଆପଣ “ଓଡିଆ”ରେ ପ୍ରଶ୍ନ ପଚାରିପାରିବେ। ଭାଷା ବଦଳାଇବା ପାଇଁ ଏଠାରେ କ୍ଲିକ୍ କରନ୍ତୁ ☰`,
    'mr': `तुम्ही "मराठी" भाषा निवडली आहे. आता तुम्ही "मराठी" मध्ये प्रश्न विचारू शकता" येथे भाषा बदला ☰`
}

export const disclaimer = {
    "ASHA_DEMO": {
      en: "The answers provided by the AI Assistant are based on the training modules published by the Ministry of Health and Family Welfare, Government of India.",
      hi: "एआई असिस्टेंट द्वारा दिए गए उत्तर, भारत सरकार के स्वास्थ्य एवं परिवार कल्याण मंत्रालय द्वारा प्रकाशित ट्रेनिंग मॉड्यूल पर आधारित हैं।",
      or: "ଏଆଇ ସହାୟକ ଦ୍ୱାରା ପ୍ରଦାନ କୃତ ଉତ୍ତରଗୁଡ଼ିକ ଭାରତ ସରକାରଙ୍କ ସ୍ୱାସ୍ଥ୍ୟ ଓ ପରିବାର କଲ୍ୟାଣ ମନ୍ତ୍ରଣାଳୟ ଦ୍ୱାରା ପ୍ରକାଶିତ ପ୍ରଶିକ୍ଷଣ ମାଡ଼ୁଲ୍‌ଗୁଡ଼ିକ ଉପରେ ଆଧାରିତ ଅଟେ।",
      mr: "एआय असिस्टेंट दिलेली उत्तरे भारत सरकारच्या आरोग्य व कुटुंब कल्याण मंत्रालयाने प्रकाशित केलेल्या प्रशिक्षण मॉड्यूलवर आधारित आहेत."
    },
    "AWW_WCD": {
      en: "The answers provided by the AI Assistant are based on the training modules published by the Ministry of Women and Child Development, Government of India.",
      hi: "एआई असिस्टेंट द्वारा दिए गए उत्तर, भारत सरकार के महिला बाल विकास मंत्रालय द्वारा प्रकाशित ट्रेनिंग मॉड्यूल पर आधारित हैं।",
      or: "ଏଆଇ ସହାୟକ ଦ୍ୱାରା ପ୍ରଦାନ କୃତ ଉତ୍ତରଗୁଡ଼ିକ ଭାରତ ସରକାରଙ୍କ ମହିଳା ଓ ଶିଶୁ ବିକାଶ ମନ୍ତ୍ରଣାଳୟ ଦ୍ୱାରା ପ୍ରକାଶିତ ପ୍ରଶିକ୍ଷଣ ମାଡ଼ୁଲ୍‌ଗୁଡ଼ିକ ଉପରେ ଆଧାରିତ।"
    },
    "CHO_CTD": {
      en: "The answers provided by the AI Assistant are based on the training modules published by the Ministry of Health and Family Welfare, Government of India.",
      hi: "एआई असिस्टेंट द्वारा दिए गए उत्तर, भारत सरकार के स्वास्थ्य एवं परिवार कल्याण मंत्रालय द्वारा प्रकाशित ट्रेनिंग मॉड्यूल पर आधारित हैं।",
      or: "ଏଆଇ ସହାୟକ ଦ୍ୱାରା ପ୍ରଦାନ କୃତ ଉତ୍ତରଗୁଡ଼ିକ ଭାରତ ସରକାରଙ୍କ ସ୍ୱାସ୍ଥ୍ୟ ଓ ପରିବାର କଲ୍ୟାଣ ମନ୍ତ୍ରଣାଳୟ ଦ୍ୱାରା ପ୍ରକାଶିତ ପ୍ରଶିକ୍ଷଣ ମାଡ଼ୁଲ୍‌ଗୁଡ଼ିକ ଉପରେ ଆଧାରିତ ଅଟେ।",
      mr: "एआय असिस्टेंट दिलेली उत्तरे भारत सरकारच्या आरोग्य व कुटुंब कल्याण मंत्रालयाने प्रकाशित केलेल्या प्रशिक्षण मॉड्यूलवर आधारित आहेत."
    },
    "ASHA_GAVI": {
      en: "The answers provided by the AI Assistant are based on the training modules published by the Ministry of Health and Family Welfare, Government of India.",
      hi: "एआई असिस्टेंट द्वारा दिए गए उत्तर, भारत सरकार के स्वास्थ्य एवं परिवार कल्याण मंत्रालय द्वारा प्रकाशित ट्रेनिंग मॉड्यूल पर आधारित हैं।",
      or: "ଏଆଇ ସହାୟକ ଦ୍ୱାରା ପ୍ରଦାନ କୃତ ଉତ୍ତରଗୁଡ଼ିକ ଭାରତ ସରକାରଙ୍କ ସ୍ୱାସ୍ଥ୍ୟ ଓ ପରିବାର କଲ୍ୟାଣ ମନ୍ତ୍ରଣାଳୟ ଦ୍ୱାରା ପ୍ରକାଶିତ ପ୍ରଶିକ୍ଷଣ ମାଡ଼ୁଲ୍‌ଗୁଡ଼ିକ ଉପରେ ଆଧାରିତ ଅଟେ।",
      mr: "एआय असिस्टेंट दिलेली उत्तरे भारत सरकारच्या आरोग्य व कुटुंब कल्याण मंत्रालयाने प्रकाशित केलेल्या प्रशिक्षण मॉड्यूलवर आधारित आहेत."
    },
    "FPC_BSHS": {
      en: "The answers provided by the AI Assistant are based on the training modules published by the Ministry of Health and Family Welfare, Government of India.",
      hi: "एआई असिस्टेंट द्वारा दिए गए उत्तर, भारत सरकार के स्वास्थ्य एवं परिवार कल्याण मंत्रालय द्वारा प्रकाशित ट्रेनिंग मॉड्यूल पर आधारित हैं।",
      or: "ଏଆଇ ସହାୟକ ଦ୍ୱାରା ପ୍ରଦାନ କୃତ ଉତ୍ତରଗୁଡ଼ିକ ଭାରତ ସରକାରଙ୍କ ସ୍ୱାସ୍ଥ୍ୟ ଓ ପରିବାର କଲ୍ୟାଣ ମନ୍ତ୍ରଣାଳୟ ଦ୍ୱାରା ପ୍ରକାଶିତ ପ୍ରଶିକ୍ଷଣ ମାଡ଼ୁଲ୍‌ଗୁଡ଼ିକ ଉପରେ ଆଧାରିତ ଅଟେ।",
      mr: "एआय असिस्टेंट दिलेली उत्तरे भारत सरकारच्या आरोग्य व कुटुंब कल्याण मंत्रालयाने प्रकाशित केलेल्या प्रशिक्षण मॉड्यूलवर आधारित आहेत."
    },
    "ANM_POC": {
      en: "The answers provided by the AI Assistant are based on the training modules published by the Ministry of Health and Family Welfare, Government of India.",
      hi: "एआई असिस्टेंट द्वारा दिए गए उत्तर, भारत सरकार के स्वास्थ्य एवं परिवार कल्याण मंत्रालय द्वारा प्रकाशित ट्रेनिंग मॉड्यूल पर आधारित हैं।",
      or: "ଏଆଇ ସହାୟକ ଦ୍ୱାରା ପ୍ରଦାନ କୃତ ଉତ୍ତରଗୁଡ଼ିକ ଭାରତ ସରକାରଙ୍କ ସ୍ୱାସ୍ଥ୍ୟ ଓ ପରିବାର କଲ୍ୟାଣ ମନ୍ତ୍ରଣାଳୟ ଦ୍ୱାରା ପ୍ରକାଶିତ ପ୍ରଶିକ୍ଷଣ ମାଡ଼ୁଲ୍‌ଗୁଡ଼ିକ ଉପରେ ଆଧାରିତ ଅଟେ।",
      mr: "एआय असिस्टेंट दिलेली उत्तरे भारत सरकारच्या आरोग्य व कुटुंब कल्याण मंत्रालयाने प्रकाशित केलेल्या प्रशिक्षण मॉड्यूलवर आधारित आहेत."
    }
};  

export const doubt = {
    en: "Type your queries here",
    hi: "अपने प्रश्न यहाँ टाइप करें",
    or: "ଆପଣଙ୍କର ପ୍ରଶ୍ନଗୁଡ଼ିକ ଏଠାରେ ଟାଇପ୍ କରନ୍ତୁ",
    mr: "आपले प्रश्न येथे टाइप करा"

}
export const errorMessageObj = (datetime, userQueryObj) => {
    return {
        "_id": uuidv4(),
        "offset": -1,
        "bot": {
            "datetime": datetime,
            "text": {
                "en": "Something went wrong. Please try again.",
                "hi": "कुछ गड़बड़ हुई है। कृपया दोबारा प्रयास करें।"
            },
            "options": [],
            "suggested_questions": {},
            "sources": [],
            "success": false,
            "error": {
                "code": "303",
                "message": "Internal Server Error"
            },
            "starred": false,
            "welcome": false,
            "answer_type": ""
        },
        "user": {
            "datetime": datetime,
            "type": userQueryObj?.values[0]?.type,
            "text": userQueryObj?.values[0]?.value,
            "image": userQueryObj?.image
        }
    }
}

export const welcomeMessageBlockText = {
    "html": {
        "en": `<p style=\"display: inline-block;\">👋  Hello! I’m <strong>HealthVaani</strong>, your AI Assistant! </p>
        <p style=\"display: inline-block;\">Feel free to ask me <strong>any health related questions</strong> — even if it’s the <strong>same question more than once,</strong> I truly encourage it! </p>
        <p style=\"display: inline-block;\">💬 Your conversations with me will always stay <strong>private and secure.</strong></p>`,
        "hi": `<p style=\"display: inline-block;\">👋  नमस्ते! मैं हूँ <strong>हेल्थवाणी</strong>, आपकी एआई सहायक!</p>
        <p style=\"display: inline-block;\">आप मुझसे <strong>स्वास्थ्य से जुड़े कोई भी सवाल</strong> बेझिझक पूछ सकती हैं — <strong>चाहे वही सवाल बार-बार क्यों न हो</strong>, मैं उसका स्वागत करती हूँ।</p>
        <p style=\"display: inline-block;\">💬  आपकी बातें मेरे पास <strong>सुरक्षित और गोपनीय</strong> रहेंगी।</p>`,
        "or": `<p style=\"display: inline-block;\">👋 ନମସ୍କାର! ମୁଁ ହେଉଛି ହେଲ୍ଥଭାଣୀ, ଆପଣଙ୍କର AI ସହାୟିକା!</p>
        <p style=\"display: inline-block;\">ଆପଣ ମୋତେ <strong>ସ୍ୱାସ୍ଥ୍ୟ ସଂପର୍କିତ କୌଣସି ପ୍ରଶ୍ନ</strong> ନିର୍ଭୟରେ ପଚାରିପାରିବେ — <strong>ସେଇ ପ୍ରଶ୍ନ ଯଦି ବାରମ୍ବାର ହୁଏ ମଧ୍ୟ</strong>, ମୁଁ ତାକୁ ସ୍ୱାଗତ କରିବି।</p>
        <p style=\"display: inline-block;\">💬 ଆପଣଙ୍କର କଥାବାର୍ତ୍ତା <strong>ସୁରକ୍ଷିତ ଓ ଗୋପନୀୟ</strong> ରହିବ।</p>`,
        "mr": `<p style=\"display: inline-block;\">👋 नमस्कार! मी आहे <strong>हेल्थवाणी</strong>, तुमची एआय सहाय्यक!</p>
        <p style=\"display: inline-block;\">तुम्ही मला <strong>आरोग्याशी संबंधित कोणतेही प्रश्न</strong> निर्धास्तपणे विचारू शकता — तोच प्रश्न वारंवार विचारला तरीही, मी त्याचे स्वागत करते.</p>
        <p style=\"display: inline-block;\">💬 तुमचे माझ्याशी झालेले संभाषण नेहमी <strong>सुरक्षित आणि गोपनीय</strong> राहील।</p>`
    },
    "audio": {
        "en": "Hello! I’m HealthVaani, your AI Assistant! Feel free to ask me any health related questions even if it’s the same question more than once, I truly encourage it! Your conversations with me will always stay private and secure.",
        "hi": "नमस्ते! मैं हूँ हेल्थवाणी, आपकी एआई सहायक! आप मुझसे स्वास्थ्य से जुड़े कोई भी सवाल बेझिझक पूछ सकती हैं चाहे वही सवाल बार-बार क्यों न हो, मैं उसका स्वागत करती हूँ।  आपकी बातें मेरे पास सुरक्षित और गोपनीय रहेंगी।",
        "or": "ନମସ୍କାର! ମୁଁ ହେଉଛି ହେଲ୍ଥଭାଣୀ, ଆପଣଙ୍କର AI ସହାୟିକା! ଆପଣ ମୋତେ ସ୍ୱାସ୍ଥ୍ୟ ସଂପର୍କିତ କୌଣସି ପ୍ରଶ୍ନ ନିର୍ଭୟରେ ପଚାରିପାରିବେ ସେଇ ପ୍ରଶ୍ନ ଯଦି ବାରମ୍ବାର ହୁଏ ମଧ୍ୟ, ମୁଁ ତାକୁ ସ୍ୱାଗତ କରିବି। ଆପଣଙ୍କର କଥାବାର୍ତ୍ତା ମୋ ପାଖରେ ସୁରକ୍ଷିତ ଓ ଗୋପନୀୟ ରହିବ।",
        "mr": "नमस्कार! मी आहे हेल्थवाणी, तुमची एआय सहाय्यक! तुम्ही मला आरोग्याशी संबंधित कोणतेही प्रश्न निर्धास्तपणे विचारू शकता, तोच प्रश्न वारंवार विचारला तरीही मी त्याचे स्वागत करते. तुमचे माझ्याशी झालेले संभाषण नेहमी सुरक्षित आणि गोपनीय राहील."
    }
}

export const welcomeMessageBlockTextSecond = {
    "html": {
        "en": `<p style=\"display: inline-block;\">If I’m ever unable to answer something, don’t worry — <strong>your question is saved,</strong> and I’m always learning to get better for you.</p>`,
        "hi": `<p style=\"display: inline-block;\">अगर कभी मैं जवाब न दे पाऊँ, तो निश्चिंत रहें — <strong>आपका सवाल दर्ज हो गया है,</strong> और मैं हमेशा खुद को बेहतर बना रही हूँ।</p>`,
        "or": `<p style=\"display: inline-block;\">ଯଦି କେବେ ମୁଁ ଉତ୍ତର ଦେଇପାରିନାହିଁ, ତେବେ ଚିନ୍ତା କରିବେନି — <strong>ଆପଣଙ୍କର ପ୍ରଶ୍ନ ଲିପିବଦ୍ଧ ହୋଇଯାଇଛି,</strong> ଏବଂ ମୁଁ ସଦା ନିଜକୁ ଉନ୍ନତ କରୁଛି।</p>`,
        "mr": `<p style=\"display: inline-block;\">जर कधी मी उत्तर देऊ शकले नाही, तर काळजी करू नका — <strong>तुमचा प्रश्न जतन झाला आहे,</strong> आणि मी तुमच्यासाठी अधिक चांगली होण्यासाठी सतत शिकत आहे.</p>`,
    },
    "audio": {
        "en": "If I’m ever unable to answer something, don’t worry — your question is saved, and I’m always learning to get better for you.",
        "hi": "अगर कभी मैं जवाब न दे पाऊँ, तो निश्चिंत रहें — आपका सवाल दर्ज हो गया है, और मैं हमेशा खुद को बेहतर बना रही हूँ।",
        "or": "ଯଦି କେବେ ମୁଁ ଉତ୍ତର ଦେଇପାରିନାହିଁ, ତେବେ ଚିନ୍ତା କରିବେନି — ଆପଣଙ୍କର ପ୍ରଶ୍ନ ଲିପିବଦ୍ଧ ହୋଇଯାଇଛି, ଏବଂ ମୁଁ ସଦା ନିଜକୁ ଉନ୍ନତ କରୁଛି।",
        "mr": "जर कधी मी उत्तर देऊ शकले नाही, तर काळजी करू नका — तुमचा प्रश्न जतन झाला आहे, आणि मी तुमच्यासाठी अधिक चांगली होण्यासाठी सतत शिकत आहे."
    }
}

export const defaultChipBlockText = {
    "html": {
        "en": `<p style="display: inline-block;">
          You may ask a question or select a topic from 
          <img src="./Assets/Images/grid.svg" style=\"width: 1.5rem; margin-left: 0.2rem; margin-right: 0.2rem; display: inline;\" alt=\"grid\" />
        </p>`,
        "hi": `<p style=\"display: inline-start;\">
        आप कोई प्रश्न पूछ सकते हैं या 
        <img src='./Assets/Images/grid.svg' style="width: 1.5rem; margin-left: 0.2rem; margin-right: 0.2rem; display: inline;" alt="grid" /> 
        से कोई विषय चुन सकते हैं
    </p>`,
        "or": `<p style=\"display: inline-start;\">
        ଆପଣ ଏକ ପ୍ରଶ୍ନ ପଚାରିପାରିବେ କିମ୍ବା 
        <img src='./Assets/Images/grid.svg' style="width: 1.5rem; margin-left: 0.2rem; margin-right: 0.2rem; display: inline;" alt="grid" /> 
        ରୁ ଏକ ବିଷୟ ଚୟନ କରିପାରିବେ।
    </p>`,
    "mr": `<p style=\"display: inline-block;\">
        तुम्ही प्रश्न विचारू शकता किंवा 
        <img src='./Assets/Images/grid.svg' style="width: 1.5rem; margin-left: 0.2rem; margin-right: 0.2rem; display: inline;" alt="grid" /> 
        मधून एखादा विषय निवडू शकता.
    </p>`
    },
    "audio": {
        "en": "You may ask a question or select a topic from.",
        "hi": "आप कोई प्रश्न पूछ सकते हैं या इनमे से कोई विषय चुन सकते हैं ",
        "or": "ଆପଣ ଏକ ପ୍ରଶ୍ନ ପଚାରିପାରିବେ କିମ୍ବା ରୁ ଏକ ବିଷୟ ଚୟନ କରିପାରିବେ।",
        "mr": "तुम्ही प्रश्न विचारू शकता किंवा एखादा विषय निवडू शकता."
    }
}

export const noAnswerDefaultBlockText = {
    html: {
        en: `<p style=\"display: inline-block;\">
          If you believe your question is for an activity for your role, please try asking it in a different way or ask a different question.
        </p>`,
        hi: `<p style=\"display: inline-start;\">
        यदि आपको लगता है कि आपका प्रश्न आपके काम से संबंधित है, तो कृपया इसे अलग तरीके से पूछने का प्रयास करें या एक अलग सवाल पूछें ।
    </p>`
    },
    audio: {
        en: "If you believe your question is for an activity for your role, please try asking it in a different way or ask a different question.",
        hi: "यदि आपको लगता है कि आपका प्रश्न आपके काम से संबंधित है, तो कृपया इसे अलग तरीके से पूछने का प्रयास करें या एक अलग सवाल पूछें"
    }
}

export const validatedSameMessage = {
    en: "Thanks for sharing your feedback! 🙏 Share any other feedback here ☰",
    hi: "अपनी राय बताने के लिए धन्यवाद! 🙏 अन्य सुझाव या फीडबैक यहाँ ☰ दें!",
    or: "ଆପଣଙ୍କ ମତାମତ ଜଣାଇଥିବାରୁ ଧନ୍ୟବାଦ! 🙏 ଆପଣଙ୍କ ମତାମତ ଏଠାରେ ଜଣାନ୍ତୁ ☰",
    mr: "तुमचा फीडबॅक शेअर केल्याबद्दल धन्यवाद! 🙏 इतर सूचना किंवा अभिप्राय येथे द्या ☰"
}
